/* @ngInject */
function TaskSimpleCardController ($scope, $timeout, TasksService, ToastService) {
  $scope.today = moment().format('YYYY-MM-DD')

  activate()

  function activate () {
    $timeout(() => {
      $('.related-task-dropdown').dropdown()
    }, 1000, false)
  }

  $scope.removeTaskAttach = function () {
    TasksService.deleteRelatedTask($scope.parentTask, $scope.task.id).then(() => {
      ToastService.defaultSuccessToast()
      $scope.$emit('workflow.request-details-reload')
    }).catch(ToastService.defaultErrorToast)
  }
}

export { TaskSimpleCardController }
